import { JournalQueryResult, JournalState, StateReducer } from '../common';
import { JournalActionTypes, JournalActions } from './journal.actions';

export function getJournalReducer<TState extends JournalState = JournalState>(
  defaultResult: JournalQueryResult,
): StateReducer<TState> {
  return ((state: TState, action: JournalActions) =>
    commonJournalStateReducer(action, state, defaultResult)) as StateReducer<TState>;
}

function commonJournalStateReducer<TState extends JournalState>(
  action: JournalActions,
  state: TState,
  defaultQueryResult: JournalQueryResult,
): TState {
  switch (action.type) {
    case JournalActionTypes.SetJournalCode:
      return {
        ...state,
        journalCode: action.payload,
        records: defaultQueryResult.recordList,
        isReadyToLoadRecords: true,
      };
    case JournalActionTypes.SetQueryResult:
      return {
        ...state,
        records: action.payload.recordList,
        totalRows: action.payload.rowsCount,
        hasErrors: action.payload.hasErrors,
        isNeedToLoadRecords: false,
      };
    case JournalActionTypes.SetJournalStaticSettings:
      return {
        ...state,
        journalColumns: action.payload.columns,
      };
    // case JournalActionTypes.SetJournalInfo:
    //   return { ...state, journalColumns: action.payload.columns };
    default:
      console.warn(`Не учтенный action: "${action.type}"`);
      return state;
  }
}
